import LoginComponent from "@/views/publico/Login.vue";
import LoginInternoComponent from "@/views/publico/LoginInterno.vue";
import Cadastro from "@/views/publico/Cadastro.vue";
import RedefinirSenha from "@/views/publico/TrocarSenha.vue";
const publicoRotas = [
  {
    path: "/",
    name: "login",
    component: LoginComponent,
  },
  {
    path: "/cadastro",
    name: "cadastro",
    component: Cadastro,
  },
  {
    path: "/interno",
    name: "login-interno",
    component: LoginInternoComponent,
  },
  {
    path: "/trocar-senha",
    name: "trocar-senha",
    component: RedefinirSenha,
  }
];

export { publicoRotas };
